import React from "react";
import {
  Description,
  InsertDriveFileOutlined,
  PictureAsPdf,
  TableChart,
  Slideshow,
  Audiotrack,
  Videocam,
  FolderZip,
  Code,
  TextSnippet,
  Image,
  Brush,
  Folder,
  Email,
} from "@mui/icons-material";


import { getFileExtension } from "common/utilities";

interface FileIconProps {
  filename: string;
  idtype?: number; // Optional existing idtype logic
  fontSize?: "inherit" | "small" | "medium" | "large";
  color?: "primary" | "secondary" | "action" | "error" | "disabled" | "inherit";

}

const FileIcon: React.FC<FileIconProps> = ({ filename, idtype, fontSize = "medium", color = "inherit" }) => {

  const extension = getFileExtension(filename) || "";

  // 1. Check existing idtype logic for compatibility with Google Drive types etc.
  if (idtype) {
    if (idtype === 21) return <Folder fontSize={fontSize} color={color} />;
    if (idtype === 22) return <Description fontSize={fontSize} color={color} />;
    if (idtype === 23) return <TableChart fontSize={fontSize} color={color} />;
    if (idtype === 24) return <Slideshow fontSize={fontSize} color={color} />;
    if (idtype === 25) return <Brush fontSize={fontSize} color={color} />;
  }

  // 2. Map by extension for all other files
  switch (extension) {
    // Documents
    case "pdf":
      return <PictureAsPdf fontSize={fontSize} color={color} />;
    case "doc":
    case "docx":
    case "odt":
    case "rtf":
      return <Description fontSize={fontSize} color={color} />;
    
    // Spreadsheets
    case "xls":
    case "xlsx":
    case "csv":
    case "ods":
      return <TableChart fontSize={fontSize} color={color} />;

    // Presentations
    case "ppt":
    case "pptx":
    case "odp":
      return <Slideshow fontSize={fontSize} color={color} />;

    // Audio
    case "mp3":
    case "wav":
    case "ogg":
    case "m4a":
    case "flac":
    case "aac":
      return <Audiotrack fontSize={fontSize} color={color} />;

    // Video
    case "mp4":
    case "mkv":
    case "avi":
    case "mov":
    case "wmv":
    case "webm":
      return <Videocam fontSize={fontSize} color={color} />;



    // Email
    case "eml":
      return <Email fontSize={fontSize} color={color} />;

    // Archives
    case "zip":
    case "rar":
    case "7z":
    case "tar":
    case "gz":
      return <FolderZip fontSize={fontSize} color={color} />;

    // Images (fallthrough if no thumbnail)
    case "jpg":
    case "jpeg":
    case "png":
    case "gif":
    case "bmp":
    case "webp":
    case "svg":
      return <Image fontSize={fontSize} color={color} />;

    // Code / Scripts
    case "js":
    case "ts":
    case "tsx":
    case "jsx":
    case "py":
    case "html":
    case "css":
    case "json":
    case "sql":
    case "xml":
      return <Code fontSize={fontSize} color={color} />;

    // Text
    case "txt":
    case "log":
    case "md":
      return <TextSnippet fontSize={fontSize} color={color} />;

    default:
      return <InsertDriveFileOutlined fontSize={fontSize} color={color} />;
  }
};

export default FileIcon;
